import React, { useState, useEffect, useRef } from "react";
import data from "./../soal.json";
import clicksound from './music/click.mp3';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const ModalSoalBekel = ({
  show,
  onClose,
  Englishscore0,
  SetEnglishScore0,
  selectedTopic,
  setIsAnswer,
}) => {
  const { t } = useTranslation();
  const [questionType, setQuestionType] = useState(null);
  const [question, setQuestion] = useState(null);
  const [choices, setChoices] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [timeLeft, setTimeLeft] = useState(10);
  const [inputAnswer, setInputAnswer] = useState("");
  const [inputFields, setInputFields] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [highlightedAnswer, setHighlightedAnswer] = useState(null);
  const [isAnswered, setIsAnswered] = useState(false);
  const [randomClue, setRandomClue] = useState("");
  const [letterUsageCount, setLetterUsageCount] = useState({}); // Tracks how many times each letter has been used
  const [letterRequiredCount, setLetterRequiredCount] = useState({}); // Tracks how many times each letter is required
  const inputRefs = useRef([]);
  const [letterOptions, setLetterOptions] = useState([]);
  const [trueword, settrueword] = useState("")
  const clickSoundRef = useRef(null); // Reference to the click sound

  useEffect(() => {
    if (show) {
      setIsAnswer(false);
      const randomType =
        Math.random() < 0.5 ? "multipleChoice" : "fillInTheBlank";
      if (randomType === "multipleChoice") {
        setTimeLeft(10);
        generateQuestionMC(selectedTopic);
      } else {
        setTimeLeft(25);
        generateQuestionFillBlank(selectedTopic);
      }
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      const timer = setInterval(() => {
        setTimeLeft((prevTimeLeft) => {
          if (prevTimeLeft === 1) {
            clearInterval(timer);
            if (questionType === "multipleChoice") {
              handleChoiceClick(null);
            } else if (questionType === "fillInTheBlank") {
              handleSubmitAnswer();
            }
            return 0;
          }
          return prevTimeLeft - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [show, questionType, timeLeft]);

  const getRandomInt = (max) => Math.floor(Math.random() * max);

  const generateQuestionMC = (topic) => {
    const words = data.categories[topic];
    const randomWordObj = words[getRandomInt(words.length)];

    let choices = [randomWordObj.meaning];
    while (choices.length < 3) {
      const randomChoice = words[getRandomInt(words.length)].meaning;
      if (!choices.includes(randomChoice)) {
        choices.push(randomChoice);
      }
    }

    choices.sort(() => Math.random() - 0.5);

    setQuestion(randomWordObj.word);
    setChoices(choices);
    setCorrectAnswer(randomWordObj.meaning);
    setQuestionType("multipleChoice");
    setHighlightedAnswer(null);
    setSelectedChoice(null);
    setIsAnswered(false);
  };

  const generateQuestionFillBlank = (topic) => {
    const words = data.categories[topic];
    const randomWordObj = words[getRandomInt(words.length)];

    // Menghilangkan spasi terakhir yang tidak perlu
    const word = randomWordObj.meaning.trim();
    const wordLength = word.length;

    // Menghitung jumlah petunjuk yang akan diberikan
    const clueCount =
      wordLength >= 16
        ? 13
        : wordLength >= 13
        ? 11
        : wordLength >= 11
        ? 9
        : wordLength >= 9
        ? 7
        : wordLength >= 7
        ? 5
        : wordLength >= 5
        ? 3
        : wordLength >= 4
        ? 2
        : 1;

    const randomClue =
      randomWordObj.clues[getRandomInt(randomWordObj.clues.length)];
    setRandomClue(randomClue);

    // Tentukan posisi dari huruf yang akan diberikan sebagai petunjuk
    const cluePositions = new Set();
    while (cluePositions.size < clueCount) {
      cluePositions.add(getRandomInt(wordLength));
    }

    // Buat array untuk field input dan nilai awal
    const fields = Array(wordLength).fill(null);
    const initialInputValues = Array(wordLength).fill("");

    // Set huruf petunjuk dan pastikan karakter spasi diganti dengan underscore
    cluePositions.forEach((pos) => {
      if (word[pos] !== " ") {
        fields[pos] = word[pos]; // huruf yang sudah diketahui
        initialInputValues[pos] = word[pos]; // langsung mengisi huruf yang diketahui
      } else {
        fields[pos] = "_"; // mengganti spasi dengan underscore
        initialInputValues[pos] = "_"; // tetap menampilkan underscore di input
      }
    });

    // Kotak kosong yang harus diisi (hanya kotak yang tidak ada petunjuk dan bukan spasi)
    const emptyBoxes = wordLength - cluePositions.size;

    // Generate huruf yang benar hanya untuk kotak kosong
    let correctLettersForEmptyBoxes = word
      .toUpperCase()
      .split("")
      .filter((_, index) => !cluePositions.has(index) && word[index] !== " "); // Huruf untuk kotak kosong saja, kecuali spasi

    // Generate huruf random pengecoh
    let randomLetters = [];

    // Tambahkan huruf random yang tidak ada di kata yang benar
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    while (randomLetters.length < 2) {
      // hanya menambahkan 2 huruf pengecoh
      const randomLetter = alphabet[getRandomInt(alphabet.length)];
      if (
        !correctLettersForEmptyBoxes.includes(randomLetter) &&
        !randomLetters.includes(randomLetter)
      ) {
        randomLetters.push(randomLetter);
      }
    }

    // Gabungkan huruf yang benar untuk kotak kosong dengan huruf pengecoh
    const combinedLetters = [...correctLettersForEmptyBoxes, ...randomLetters];

    // Acak urutan huruf
    const shuffledLetters = combinedLetters.sort(() => Math.random() - 0.5);
    const requiredLettersCount = {};
    correctLettersForEmptyBoxes.forEach((letter) => {
      requiredLettersCount[letter] = (requiredLettersCount[letter] || 0) + 1;
    });

    setLetterRequiredCount(requiredLettersCount); // Set required counts
    setLetterUsageCount({}); 

    // Set pilihan huruf yang akan muncul
    setLetterOptions(shuffledLetters); // Set pilihan huruf yang bisa dipilih
    setQuestion(word.replace(/\s/g, "_")); // Ganti spasi dengan underscore di tampilan soal
    setInputFields(fields); // Set kotak jawaban
    setCorrectAnswer(word.split("")); // Set jawaban yang benar
    setInputValues(initialInputValues); // Nilai awal kotak input
    setQuestionType("fillInTheBlank");
    setIsAnswered(false);
  };

  const playClickSound = () => {
    clickSoundRef.current.currentTime = 0;
    clickSoundRef.current.play();
  };

  const handleChoiceClick = (choice) => {
    if (isAnswered) return; // Pastikan hanya bisa sekali klik
    playClickSound();

    setSelectedChoice(choice);
    setIsAnswered(true); // Update state secepatnya setelah klik untuk mencegah klik ulang

    if (choice === correctAnswer) {
      SetEnglishScore0(Englishscore0 + 100);
    }
    setHighlightedAnswer(correctAnswer);

    // Set timeout untuk menutup modal setelah beberapa saat
    setTimeout(() => {
      setIsAnswer(true);
      onClose(false); // Pastikan modal ditutup dengan benar
      setSelectedChoice(null);
      setHighlightedAnswer(null); // Reset state agar komponen tidak dirender ulang
    }, 2000);
  };

  const handleInputChange = (index, value) => {
    // Pastikan input yang sama tidak menimpa input yang lain dengan indeks yang berbeda
    const updatedValues = [...inputValues];
    if (inputFields[index] === null) {
      updatedValues[index] = value.toUpperCase();
    }

    setInputValues(updatedValues);

    // Pindah ke input berikutnya jika ada
    if (value && index < inputRefs.current.length - 1) {
      if (inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

   const handleLetterClick = (letter) => {
     if (isAnswered) return;
     playClickSound();

     // Temukan index input kosong berikutnya yang belum diisi
     const emptyIndices = inputValues.reduce((indices, val, index) => {
       if (val === "" && inputFields[index] === null) {
         indices.push(index);
       }
       return indices;
     }, []);

     if (emptyIndices.length > 0) {
       const emptyIndex = emptyIndices[0];
       handleInputChange(emptyIndex, letter);

       // Update penggunaan huruf
       setLetterUsageCount((prevUsage) => {
         const newUsage = { ...prevUsage };
         newUsage[letter] = (newUsage[letter] || 0) + 1;

         // Jika penggunaan huruf sudah sama dengan yang dibutuhkan, nonaktifkan huruf
         if (newUsage[letter] >= letterRequiredCount[letter]) {
           // Nonaktifkan huruf di UI atau tidak membiarkannya di-klik lagi
         }

         return newUsage;
       });

       // Fokus ke kotak input berikutnya
       if (inputRefs.current[emptyIndex + 1]) {
         inputRefs.current[emptyIndex + 1].focus();
       }
     }
   };

  const handleSubmitAnswer = () => {
    if (isAnswered) return;
    playClickSound();
    setIsAnswered(true);

    const correctWord = correctAnswer.join("").toLowerCase();
    const userAnswer = inputValues.join("").toLowerCase();

    if (userAnswer === correctWord) {
      SetEnglishScore0(Englishscore0 + 100);
    }

    const updatedInputFields = inputFields.map((field, index) => {
      if (field === null && userAnswer[index] !== correctWord[index]) {
        return "incorrect";
      } else if (field === null && userAnswer[index] === correctWord[index]) {
        return "correct";
      } else {
        return field;
      }
    });
    setIsAnswer(true);
    setInputFields(updatedInputFields);
    setHighlightedAnswer(correctAnswer.join(""));
    settrueword(correctWord);
    setTimeout(() => {
      setIsAnswer(true);
      onClose(false);
      setInputValues([]);
      setHighlightedAnswer(null);
    }, 1000);
  };

  return (
    show && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="quiz-card bg-white rounded-lg p-8 w-auto shadow-lg">
          <audio ref={clickSoundRef} src={clicksound} />
          <div className="timer text-center text-2xl mb-4">{timeLeft}</div>
          <div
            className={`progress-bar h-2 rounded mb-4 ${
              questionType === "multipleChoice"
                ? "duration-10s"
                : "duration-15s"
            }`}
          ></div>
          {questionType === "multipleChoice" && (
            <div>
              <div className="question mb-4 text-lg font-semibold text-center">
                What is {question} in English?
              </div>
              <div className="options flex flex-col gap-2">
                {choices.map((choice, index) => (
                  <button
                    key={index}
                    onClick={() => handleChoiceClick(choice)}
                    className={`option w-full py-2 px-4 rounded ${
                      selectedChoice === choice
                        ? choice === correctAnswer
                          ? "bg-green-500 text-white"
                          : "bg-red-500 text-white"
                        : highlightedAnswer === choice
                        ? "bg-green-500 text-white"
                        : "bg-gray-200"
                    }`}
                    disabled={isAnswered} // Disable button setelah jawaban diberikan
                  >
                    {choice}
                  </button>
                ))}
              </div>
            </div>
          )}
          {questionType === "fillInTheBlank" && (
            <div className="p-4 flex flex-col items-center">
              <div className="question mb-3 lg:text-xl sm:text-lg font-semibold text-center">
                {randomClue}
              </div>
              <div className="word-inputs flex gap-2 justify-center items-center text-center">
                {inputFields.map((field, index) => (
                  <input
                    showSoftInputOnFocus={false}
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={inputValues[index]}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    disabled={field !== null || isAnswered}
                    className={`w-8 h-8 lg:w-10 lg:h-10 text-center uppercase border-b-4 text-xl lg:text-2xl font-m ${
                      field === "incorrect"
                        ? "border-red-500 text-red-500"
                        : field === "correct"
                        ? "border-green-500 text-green-500"
                        : "border-gray-400"
                    }`}
                    style={{
                      padding: "0",
                      margin: "0 auto",
                      fontSize: "24px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                  />
                ))}
              </div>
              <div className="keyboard flex flex-wrap justify-center mt-4">
                {isAnswered ? (
                  <p className="trueword-display text-green-600 font-bold text-xl">
                    {trueword}
                  </p>
                ) : (
                  <div className="letters-container flex justify-center items-center gap-2 mt-4">
                    {letterOptions.map((letter, index) => (
                      <button
                        key={index}
                        onClick={() => handleLetterClick(letter)}
                        className="letter-button w-10 h-10 bg-blue-500 text-white rounded-lg"
                        disabled={
                          letterUsageCount[letter] >=
                          (letterRequiredCount[letter] || 0)
                        }
                      >
                        {letter}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <button
                onClick={handleSubmitAnswer}
                className="submit-button w-28 mt-5 text-center py-2 rounded-lg text-lg font-semibold bg-green-500 text-white shadow-lg"
              >
                {t("submit")}
              </button>
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default ModalSoalBekel;
